import { AfterViewInit, Directive, ElementRef, HostListener, inject, output } from '@angular/core';

@Directive({
    selector: '[tranDropdownKeyboard]'
})
export class DropdownKeyboardDirective implements AfterViewInit {
    public readonly closeRequested = output<void>();

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    public ngAfterViewInit(): void {
        this.focusInitial();
    }

    public focusInitial(): void {
        requestAnimationFrame(() => {
            const selectedBtn =
                this.host.nativeElement.querySelector<HTMLButtonElement>('button[data-selected="true"]') ??
                this.host.nativeElement.querySelector<HTMLButtonElement>('button');

            if (selectedBtn) {
                selectedBtn.focus();
            } else {
                this.host.nativeElement.focus();
            }
        });
    }

    @HostListener('focusout', ['$event'])
    protected onFocusOut(event: FocusEvent): void {
        const nextFocusedElement = event.relatedTarget as Node | null;

        if (nextFocusedElement && this.host.nativeElement.contains(nextFocusedElement)) return;

        this.closeRequested.emit();
    }

    @HostListener('keydown', ['$event'])
    protected onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Tab' || event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closeRequested.emit();
            return;
        }

        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        event.preventDefault();
        event.stopPropagation();

        const options = Array.from(this.host.nativeElement.querySelectorAll<HTMLButtonElement>('button'));
        if (options.length === 0) return;

        const currentIndex = options.indexOf(this.host.nativeElement.ownerDocument.activeElement as HTMLButtonElement);
        const isMovingDown = event.key === 'ArrowDown';

        if (currentIndex === -1) {
            options[isMovingDown ? 0 : options.length - 1].focus();
            return;
        }

        const direction = isMovingDown ? 1 : -1;
        const nextIndex = (currentIndex + direction + options.length) % options.length;

        options[nextIndex].focus();
    }
}
